import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0fe6dd57&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=0fe6dd57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe6dd57",
  null
  
)

export default component.exports